var _excluded = ["name", "nameColor", "extension", "extensionColor", "isExtensionBolded", "typography", "align"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
import styled, { css } from "styled-components";
import TextAtm from "../../atoms/TextAtm";
var Wrapper = styled(TextAtm).withConfig({
  componentId: "sc-198rp09-0"
})(function (_ref) {
  var $align = _ref.$align;
  return css(["display:flex;", " ", ""], $align === "center" && css(["justify-content:center;"]), $align === "right" && css(["justify-content:flex-end;"]));
});
var Name = styled.span.withConfig({
  componentId: "sc-198rp09-1"
})(["overflow:hidden;text-overflow:ellipsis;white-space:nowrap;"]);
var Extension = styled(TextAtm).withConfig({
  componentId: "sc-198rp09-2"
})(["flex-shrink:0;"]);
function DomainNameMol(_ref2) {
  var name = _ref2.name,
    nameColor = _ref2.nameColor,
    extension = _ref2.extension,
    extensionColor = _ref2.extensionColor,
    isExtensionBolded = _ref2.isExtensionBolded,
    typography = _ref2.typography,
    align = _ref2.align,
    restProps = _objectWithoutProperties(_ref2, _excluded);
  return /*#__PURE__*/React.createElement(Wrapper, _extends({
    typography: typography,
    align: align,
    color: nameColor,
    $align: align
  }, restProps), /*#__PURE__*/React.createElement(Name, null, name), /*#__PURE__*/React.createElement(Extension, {
    color: extensionColor,
    isBold: isExtensionBolded
  }, ".", extension));
}
export default DomainNameMol;